export function cleanRegimeName(label = "") {
    return label
        .replaceAll("Live:", "")
        .replaceAll("Ready:", "")
        .replace(/\s*\(promoted\)\s*$/i, "")
        .trim()
}
